import React from 'react'
import { StreamData } from 'types/streamData'
import { WidgetId } from 'features/types'
import StreamSymbol from 'enums/StreamSymbol'
import { RegularSoundbite } from './RegularSoundbite'
import { VocSoundbite } from './VocSoundbite'
import { PodcastSoundbite } from './PodcastSoundbite'

type SoundbiteProps = {
  widgetId: WidgetId
  streamData: StreamData
  serialNumber: number
}

export const Soundbite = ({
  widgetId,
  streamData,
  serialNumber
}: SoundbiteProps): React.ReactElement => {
  const { dataStream, isDocumentMode } = streamData

  if (dataStream === StreamSymbol.VOC) {
    return <VocSoundbite widgetId={widgetId} streamData={streamData} serialNumber={serialNumber} />
  }
  if (dataStream === StreamSymbol.PODCAST && isDocumentMode) {
    return (
      <PodcastSoundbite widgetId={widgetId} streamData={streamData} serialNumber={serialNumber} />
    )
  }

  return (
    <RegularSoundbite widgetId={widgetId} streamData={streamData} serialNumber={serialNumber} />
  )
}

export default Soundbite
